/* TrueSanity product page v2 — option pickers, price/"We make", manifest, gallery, delivery, cart.
   Reads the JSON rendered by sections/main-product-v2.liquid (same metafields as the current page). */
/* Lifecycle: everything this file hooks onto window/document goes through __ts2Life, so the in-place
   product switch (pdp-v2-swap.js) can release the old product's handlers before this file runs again
   for the new one. Running it again first switches the previous run off. */
var __ts2Life = (function () {
  if (window.__ts2Life) { try { window.__ts2Life.kill(); } catch (e) {} }
  var ac = window.AbortController ? new AbortController() : null, timers = [], obs = [], dead = false;
  return (window.__ts2Life = {
    on: function (t, ev, fn, opts) {
      var o = (opts && typeof opts === 'object') ? Object.assign({}, opts) : { capture: !!opts };
      if (ac) o.signal = ac.signal;
      t.addEventListener(ev, fn, o);
    },
    every: function (id) { timers.push(id); return id; },
    watch: function (m) { obs.push(m); return m; },
    alive: function () { return !dead; },
    kill: function () { dead = true; if (ac) ac.abort(); timers.forEach(clearInterval); obs.forEach(function (m) { try { m.disconnect(); } catch (e) {} }); }
  });
})();
(function () {
  'use strict';

  var root = document.querySelector('.ts2');
  if (!root) return;
  var data = JSON.parse(root.querySelector('[data-ts2-json]').textContent);
  /* Preview-only demo: ?ts2_demo=chain adds sample chain choices so the chain picker can be reviewed
     on a product that has none yet. Add to Bag is disabled in this mode (the variants are not real). */
  var DEMO = /[?&]ts2_demo=chain\b/.test(location.search) && data.options.indexOf('Chain') < 0;
  if (DEMO) {
    var demoChains = [['Cable 0.85mm / 16 in', 0], ['Cable 0.85mm / 18 in', 2000], ['Singapore 0.85mm / 18 in', 6000], ['Singapore 0.85mm / 20 in', 8000], ['No Chain', -10000]];
    var nv = [], did = 1;
    data.variants.forEach(function (v) {
      demoChains.forEach(function (c) {
        var x = JSON.parse(JSON.stringify(v));
        x.id = 900000000 + did++; x.options = v.options.concat([c[0]]); x.price = v.price + c[1]; x.chainType = c[0];
        nv.push(x);
      });
    });
    data.variants = nv; data.options = data.options.concat(['Chain']);
  }
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };

  /* ---------- helpers ---------- */
  function money(cents) {
    var n = Math.round(cents) / 100;
    var whole = Math.round(n) === n;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
  }
  function money2(cents) { return '$' + (Math.round(cents) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function moneyRound(cents) { return '$' + Math.round(cents / 100).toLocaleString('en-US'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function isUS() { var c = null; try { c = localStorage.getItem('countryus'); } catch (e) {} return c !== 'no'; }

  var OPT = data.options;
  var V = data.variants;
  var kind = function (name) {
    var n = name.toLowerCase();
    if (/carat/.test(n)) return 'carat';
    if (/metal/.test(n)) return 'metal';
    if (/^size$|ring size/.test(n)) return 'size';
    if (/chain/.test(n)) return 'chain';
    if (/back/.test(n)) return 'back';
    return 'chips';
  };

  /* ---------- state ---------- */
  var sel = [];
  function findVariant(opts) {
    for (var i = 0; i < V.length; i++) {
      var ok = true;
      for (var j = 0; j < opts.length; j++) if (V[i].options[j] !== opts[j]) { ok = false; break; }
      if (ok) return V[i];
    }
    return null;
  }
  function initialVariant() {
    var p = new URLSearchParams(location.search);
    var id = parseInt(p.get('variant') || p.get('variant_id'), 10);
    var v = id && V.filter(function (x) { return x.id === id; })[0];
    if (v) return v;
    var pop = OPT.map(function (o) { return data.popular[o]; });
    var best = null, bestScore = -1;
    V.forEach(function (x) {
      var s = 0; x.options.forEach(function (val, i) { if (pop[i] && pop[i] === val) s++; });
      if (x.available) s += 0.5;
      if (s > bestScore) { best = x; bestScore = s; }
    });
    return best || V[0];
  }
  var current = initialVariant();
  var SIZE_I = OPT.map(kind).indexOf('size');
  var sizeChosen = SIZE_I < 0 || /[?&]variant(_id)?=/.test(location.search);
  sel = current.options.slice();

  function valuesFor(i) {
    var seen = []; V.forEach(function (v) { if (seen.indexOf(v.options[i]) < 0) seen.push(v.options[i]); });
    return seen;
  }
  function variantWith(i, val) {
    var o = sel.slice(); o[i] = val;
    var exact = findVariant(o);
    if (exact || kind(OPT[i]) === 'chain') return exact;
    // no exact match (e.g. a large carat that only comes on the 1.2mm chain): keep every other choice
    // and let the chain follow, so the chip never looks sold out and tapping it switches the chain
    var ci = OPT.map(kind).indexOf('chain');
    if (ci < 0) return null;
    var m = V.filter(function (x) { return x.options.every(function (v, j) { return j === ci || v === o[j]; }); });
    return m.filter(function (x) { return x.available; })[0] || m[0] || null;
  }

  /* ---------- option rows ---------- */
  var optWrap = $('[data-ts2-options]');
  var foldWrap = $('[data-ts2-folds]');

  function metalStyle(val) {
    var v = val.toLowerCase();
    if (/platinum/.test(v)) return 'radial-gradient(circle at 35% 30%,#f7f8fa,#c9ccd3 60%,#9aa0aa)';
    if (/black/.test(v)) return 'radial-gradient(circle at 35% 30%,#6b6b6b,#2b2b2b 60%,#0e0e0e)';
    if (/rose/.test(v)) return 'radial-gradient(circle at 35% 30%,#fbe0d3,#e2a98f 60%,#b87a60)';
    if (/yellow/.test(v)) return 'radial-gradient(circle at 35% 30%,#fff1c2,#e3bb5a 60%,#b48a2e)';
    if (/silver/.test(v)) return 'radial-gradient(circle at 35% 30%,#ffffff,#d9dbe0 60%,#b5b9c1)';
    return 'radial-gradient(circle at 35% 30%,#ffffff,#d6d8de 60%,#aeb2bb)';
  }
  function metalTag(val) {
    if (/platinum/i.test(val)) return 'PT';
    var m = val.match(/(\d{1,2})\s*k/i); if (m) return m[1] + 'K';
    if (/silver/i.test(val)) return 'SS';
    return '';
  }
  function short(val, k) {
    if (k === 'carat') return val.replace(/\s*cts?\.?$/i, '');
    return val;
  }

  function nice(v) {
    v = String(v || '');
    return /[A-Z]{3}/.test(v) && v === v.toUpperCase() ? titleCase(v) : v;
  }
  function buildRows() {
    optWrap.innerHTML = '';
    foldWrap.innerHTML = '';
    OPT.forEach(function (name, i) {
      var k = kind(name);
      var vals = valuesFor(i);
      if (vals.length < 2 && k !== 'chain' && k !== 'back' && k !== 'carat') return; // carat always shows, even with one weight
      if (k === 'chain' || k === 'back') { foldWrap.appendChild(buildFold(name, i, k, vals)); return; }
      var row = document.createElement('div');
      row.className = 'ts2-row';
      row.innerHTML = '<div class="ts2-row__label"><strong>' + esc(name) + ':</strong> <span data-cur></span></div>';
      var list = document.createElement('div');
      list.className = k === 'carat' ? 'ts2-carat' : k === 'metal' ? 'ts2-tiles' : k === 'size' ? 'ts2-sizes' : 'ts2-chips';
      vals.forEach(function (val) {
        var b = document.createElement('button');
        b.type = 'button';
        b.dataset.i = i; b.dataset.val = val;
        if (k === 'metal') {
          b.className = 'ts2-tile';
          b.setAttribute('aria-label', val);
          b.innerHTML = '<span class="ts2-metal" style="background:' + metalStyle(val) + ';color:' + (/black/i.test(val) ? '#e8e8e8' : '#4a4a4a') + '">' + metalTag(val) + '</span>';
        } else if (k === 'carat') {
          b.className = 'ts2-chip ts2-chip--carat';
          b.innerHTML = '<span>' + esc(short(val, k)) + '</span><small data-p></small>';
        } else {
          b.className = 'ts2-chip';
          b.textContent = nice(val);
        }
        if (data.popular[name] === val) b.classList.add('is-popular');
        b.addEventListener('click', function () { choose(i, val); });
        list.appendChild(b);
      });
      row.appendChild(list);
      if (k === 'size') {
        var hint = document.createElement('div');
        hint.className = 'ts2-sizehint';
        hint.innerHTML = '<span class="ts2-muted ts2-tiny">Swipe for more sizes</span>' +
          ($('[data-ts2-sizechart-tpl]') ? '<button type="button" class="ts2-linkbtn ts2-tiny" data-ts2-sizechart>What\'s my size?</button>' : '') +
          (data.noResize ? '<span class="ts2-tiny ts2-noresize">This ring cannot be resized</span>' : '');
        row.appendChild(hint);
      }
      optWrap.appendChild(row);
    });
  }

  function buildFold(name, i, k, vals) {
    var fold = document.createElement('div');
    fold.className = 'ts2-fold';
    var combined = vals.some(function (v) { return / \/ /.test(v); });
    fold.innerHTML =
      '<button type="button" class="ts2-fold__head" aria-expanded="false">' +
        '<span class="ts2-fold__text"><span><strong>' + (k === 'chain' ? 'Chain' : 'Back') + ':</strong> <span data-cur></span></span>' +
        '<span class="ts2-muted ts2-small" data-sub></span></span>' +
        '<span class="ts2-fold__cta">Change</span></button>' +
      '<div class="ts2-fold__body" hidden></div>';
    var body = fold.querySelector('.ts2-fold__body');
    var head = fold.querySelector('.ts2-fold__head');
    head.addEventListener('click', function () {
      var open = body.hidden;
      body.hidden = !open;
      head.setAttribute('aria-expanded', String(open));
      head.querySelector('.ts2-fold__cta').textContent = open ? 'Close' : 'Change';
    });
    if (combined) {
      // "Style / Length" values (one Shopify option) shown as two rows; "No Chain" has no length.
      var styles = [], lengths = [];
      vals.forEach(function (v) {
        var parts = v.split(' / ');
        if (styles.indexOf(parts[0]) < 0) styles.push(parts[0]);
        if (parts[1] && lengths.indexOf(parts[1]) < 0) lengths.push(parts[1]);
      });
      body.appendChild(subRow('Style', styles, function (s) {
        var curLen = (sel[i].split(' / ')[1]) || lengths[0];
        var target = vals.filter(function (v) { return v === s + ' / ' + curLen; })[0] || vals.filter(function (v) { return v.indexOf(s) === 0; })[0];
        choose(i, target);
      }, 'style'));
      body.appendChild(subRow('Length', lengths, function (l) {
        var curStyle = sel[i].split(' / ')[0];
        var target = vals.filter(function (v) { return v === curStyle + ' / ' + l; })[0];
        if (target) choose(i, target);
      }, 'length'));
    } else {
      body.appendChild(subRow(null, vals, function (v) { choose(i, v); }, 'plain'));
    }
    fold.dataset.i = i; fold.dataset.kind = k; fold.dataset.combined = combined ? '1' : '';
    return fold;
  }
  function subRow(label, vals, onPick, role) {
    var w = document.createElement('div');
    w.className = 'ts2-subrow';
    w.dataset.role = role;
    if (label) w.innerHTML = '<div class="ts2-row__label ts2-small"><strong>' + label + '</strong></div>';
    var list = document.createElement('div');
    list.className = 'ts2-chips';
    vals.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ts2-chip'; b.dataset.val = v;
      b.innerHTML = '<span>' + esc(nice(v)) + '</span><small data-p></small>';
      b.addEventListener('click', function () { onPick(v); });
      list.appendChild(b);
    });
    w.appendChild(list);
    return w;
  }

  function choose(i, val) {
    if (i === SIZE_I) { sizeChosen = true; var se = $('[data-ts2-size-error]'); if (se) se.hidden = true; }
    sel[i] = val;
    var v = findVariant(sel) || variantWith(i, val);
    if (v) sel = v.options.slice();
    if (!v) {
      // keep the tapped value, pick the closest available combination
      v = V.filter(function (x) { return x.options[i] === val && x.available; })[0] || V.filter(function (x) { return x.options[i] === val; })[0];
      if (v) sel = v.options.slice();
    }
    if (v) { current = v; render(true); }
  }

  /* ---------- pricing (same formulas as the current manifest snippets) ---------- */
  // Friendly labels; a line only shows when its theme setting label (settings.jew_*) is set and the cost is > 0,
  // exactly like jewelry-product-above-manifest.liquid.
  var NICE = { material: 'Material', backing: 'Backing', chain: 'Chain', accent: 'Diamonds & Gemstones', labor: 'Craftsmanship', logistic: 'Logistics & Security', prodlog: 'Production & Logistics', gift: 'Free gift' };
  function optVal(k) { var i = OPT.map(kind).indexOf(k); return i > -1 ? sel[i] : ''; }
  function grams(x) { if (!x) return ''; var n = parseFloat(String(x).replace(/[^0-9.]/g, '')); return isNaN(n) ? String(x) : 'approx. ' + n.toFixed(2) + ' g'; }
  // Gold chains read "1.2mm Solid Gold Chain" with only the weight under them; Silver keeps the old label until its chain cost is checked.
  function isSilver(v) { return (v.options || []).join(' ').toLowerCase().indexOf('silver') > -1; }
  function chainLabel(v) {
    var mm = String(data.chainMM || '').replace(/\s*mm\s*$/i, '').trim();
    return (!mm || isSilver(v)) ? '' : mm + 'mm Solid Gold Chain';
  }
  function titleCase(s) { return String(s || '').toLowerCase().replace(/(^|[\s(\-\/])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }); }
  function detailsFor(key, v) {
    var d = [];
    if (key === 'material') {
      if (optVal('metal')) d.push(['Metal', optVal('metal')]);
      if (v.metalWeight) d.push(['Metal weight', grams(v.metalWeight)]);
    } else if (key === 'chain') {
      if (v.chainType && !chainLabel(v)) d.push(['Chain', v.chainType]);
      if (v.chainWeight) d.push(['Chain weight', grams(v.chainWeight)]);
    } else if (key === 'backing') {
      if (v.backingType) d.push(['Back', v.backingType]);
      if (v.backingWeight) d.push(['Back weight', grams(v.backingWeight)]);
    } else if (key === 'accent') {
      var parse = function (str) {
        str = String(str || '').trim();
        if (!str || str === '-') return null;
        var p = str.split('|').map(function (x) { return x.trim(); });
        var cents = Math.round(parseFloat(String(p[2] || '').replace(/[^0-9.]/g, '')) * 100);
        return { name: p[0] || '', weight: (p[1] || '').replace(/\s*cts?\.?$/i, ''), cents: isNaN(cents) ? null : cents };
      };
      var st = v.stones || {};
      var dia = parse(st.diamond), gemS = parse(st.gem), accS = parse(st.accent);
      var ai = v.accentInfo || {};
      if (dia) d.push(['Center diamond', dia.name + (dia.weight ? ', ' + dia.weight + ' ct' : ''), dia.cents]);
      if (gemS) d.push(['Center stone', gemS.name + (gemS.weight ? ', ' + gemS.weight + ' ct' : ''), gemS.cents]);
      if (accS) {
        var accDesc = (v.accent || '').replace(/^[\s,]+|[\s,]+$/g, '').replace(/,\s*[\d.]+$/, '');
        var extra = [ai.color, ai.quality].filter(Boolean).join(' ');
        d.push(['Accent stones', [accDesc, extra, accS.weight ? accS.weight + ' ct' : ''].filter(Boolean).join(', '), accS.cents]);
      }
      if (!dia && !gemS && !accS) {
        var gem = data.gemName || '';
        var q = data.quality ? data.quality.replace(/^(lab grown|lab|natural)\s+/i, '') : '';
        if (gem) d.push(['Center stone', gem + (q ? ', ' + q + ' quality' : '')]);
        var acc = (v.accent || '').replace(/^[\s,]+|[\s,]+$/g, '');
        if (/\d$/.test(acc)) acc += ' ct';
        if (/[a-z0-9]/i.test(acc)) d.push(['Accent stones', acc]);
      }
    } else if (key === 'labor') {
      var lab = (data.labels.labor || '').split(':')[1];
      d.push(['Work', lab ? titleCase(lab.trim()) : 'Hand-forging & setting']);
      d.push(['Made', 'To order, for you']);
    }
    return d;
  }
  function giftLine(v) {
    // the free gift comes out of what we make, so it is shown as a cost line
    if (!window.TS2Gift || !window.TS2Gift.selected) return null;
    var mi = OPT.map(kind).indexOf('metal');
    var g = window.TS2Gift.selected(v.price, mi > -1 ? sel[mi] : '');
    if (!g || !g.cost) return null;
    return { key: 'gift', label: 'Free gift', cents: g.cost, details: [['', g.title + ', ' + g.variant, null], ['', 'Retail value ' + money(g.value) + ', free to you. Paid from what we make.', null]] };
  }
  // Promo discount the shopper gets on this piece (0, 0.09 or 0.11), from snippets/ts-welcome-offer.liquid.
  // What we make is shown at the price actually paid, so it drops with the discount.
  function promoPct() { try { return (window.TSPromo && window.TSPromo.pct()) || 0; } catch (e) { return 0; } }
  function paidPrice(cents) { var p = promoPct(); return p ? cents - Math.round(cents * p) : cents; }
  function manifest(v) {
    var L = data.labels, c = v.cost, price = paidPrice(v.price);
    var gl = giftLine(v);
    if (v.price >= 50000) {
      var lines = ['material', 'accent', 'labor', 'chain', 'backing', 'logistic']
        .filter(function (k) { return L[k] && c[k] > 0; })
        .map(function (k) { return { key: k, label: (k === 'chain' && chainLabel(v)) || NICE[k], cents: c[k], details: detailsFor(k, v) }; });
      if (gl && lines.length) lines.push(gl);
      var total = lines.reduce(function (a, b) { return a + b.cents; }, 0);
      if (!total) return null;
      var diff = price - total;
      var pct = Math.round(diff * 100 / price);
      return { lines: lines, diff: diff, label: 'What we make (' + pct + '%)', short: pct + '% (' + moneyRound(diff) + ')', wm: moneyRound(diff) + ' (' + pct + '%)', feeNote: 'Your price minus every cost above: ' + money2(price) + ' − ' + money2(total) + '.' };
    }
    if (L.prodlog && c.prodlog > 0) {
      var plines = [{ key: 'prodlog', label: NICE.prodlog, cents: c.prodlog, details: [] }];
      if (gl) plines.push(gl);
      var d = price - c.prodlog - (gl ? gl.cents : 0);
      var p2 = Math.round(((d / 100) - 50) * 100 / (price / 100));
      return { lines: plines, diff: d, label: 'What we make ($50 + ' + p2 + '%)', short: '$50 + ' + p2 + '% (' + moneyRound(d) + ')', wm: moneyRound(d) + ' ($50 + ' + p2 + '%)', feeNote: 'Your price minus production and logistics: ' + money2(price) + ' − ' + money2(c.prodlog) + '.' };
    }
    return null;
  }
  var openLines = {};
  function manifestHTML(m) {
    function row(key, label, amount, details, fee) {
      var head = '<span>' + esc(label) + '</span><i></i><span>' + amount + '</span>';
      if (!details || !details.length) return '<div class="ts2-mline' + (fee ? ' ts2-mline--fee' : '') + '">' + head + '</div>';
      var body = details.map(function (x) { return typeof x === 'string' ? '<p>' + esc(x) + '</p>' : '<div class="ts2-mdet"><span>' + esc(x[0]) + '</span><span>' + esc(x[1]) + '</span><span>' + (x[2] != null ? money2(x[2]) : '') + '</span></div>'; }).join('');
      return '<details class="ts2-mitem' + (fee ? ' ts2-mline--fee' : '') + '" data-key="' + key + '"' + (openLines[key] ? ' open' : '') + '><summary class="ts2-mline">' + head + '</summary><div class="ts2-mbody">' + body + '</div></details>';
    }
    return m.lines.map(function (l) { return row(l.key, l.label, money2(l.cents), l.details); }).join('') +
      row('fee', m.label, money2(m.diff), [m.feeNote], true);
  }

  /* printed-card layout: bold line + amount; details fold under a small arrow (tap to open) */
  function manifestCard(m, v) {
    var LABEL = { material: 'Material', accent: 'Gemstones / Diamonds', labor: 'Labor', chain: 'Chain', backing: 'Backing', logistic: 'Logistics', prodlog: 'Production & Logistics' };
    function detailRows(l) {
      var d = l.details || [];
      if (l.key === 'material' || l.key === 'chain' || l.key === 'backing') {
        var t = d.map(function (x) { return x[1]; }).filter(Boolean);
        return t.length ? '<div class="ts2-mcard__subrow"><span>' + esc(t.join(' : ')) + '</span><span></span></div>' : '';
      }
      return d.map(function (x) {
        return '<div class="ts2-mcard__subrow"><span>' + esc(l.key === 'accent' ? (x[1] || x[0]) : (x[0] ? x[0] + ': ' : '') + x[1]) + '</span><span>' + (x[2] != null ? money2(x[2]) : '') + '</span></div>';
      }).join('');
    }
    var total = m.lines.reduce(function (a, l) { return a + l.cents; }, 0);
    var pct = (m.label.match(/\(([^)]+)\)/) || [, Math.round(m.diff * 100 / v.price) + '%'])[1];
    return '<div class="ts2-mcard__rows">' + m.lines.map(function (l) {
      var head = '<b>' + esc(l.key === 'chain' && l.label !== NICE.chain ? l.label : (LABEL[l.key] || l.label)) + '</b><span>' + money2(l.cents) + '</span>';
      var body = detailRows(l);
      if (!body) return '<div class="ts2-mcard__row">' + head + '</div>';
      return '<details class="ts2-mcard__item" data-key="' + l.key + '"' + (openLines[l.key] ? ' open' : '') + '><summary class="ts2-mcard__row">' + head + '</summary><div class="ts2-mcard__body">' + body + '</div></details>';
    }).join('') + '</div>' +
      '<div class="ts2-mcard__rows ts2-mcard__rows--sum">' +
        '<div class="ts2-mcard__row"><b>Total Cost</b><span>' + money2(total) + '</span></div>' +
        (function () {
          // The discount comes out of our fee, not out of the costs, so say so on the card.
          var off = v.price - paidPrice(v.price);
          if (!off) return '';
          return '<div class="ts2-mcard__row ts2-mcard__row--promo"><b>Your ' + Math.round(promoPct() * 100) + '% off <small>(paid from what we make)</small></b><span>&minus;' + money2(off) + '</span></div>';
        })() +
        '<div class="ts2-mcard__row"><b>Protocol Fee <small>(what we make, ' + esc(pct) + ')</small></b><span>' + money2(m.diff) + '</span></div>' +
      '</div>' +
      (function () {
        var paid = paidPrice(v.price);
        if (paid === v.price) return '<div class="ts2-mcard__price"><span>Your Price</span><span>' + money2(v.price) + '</span></div>';
        return '<div class="ts2-mcard__price"><span>Your Price <small>(' + Math.round(promoPct() * 100) + '% off)</small></span><span><s>' + money2(v.price) + '</s> ' + money2(paid) + '</span></div>';
      })();
  }

  /* best sibling variant: exact match, else same non-carat options at the same carat position */
  function matchSibling(list) {
    if (!list || !list.length) return null;
    var title = sel.join(' / ');
    var exact = list.filter(function (x) { return x.t === title; })[0];
    if (exact) return exact;
    var ci = OPT.map(kind).indexOf('carat');
    var others = sel.filter(function (_, j) { return j !== ci; });
    var cands = list.filter(function (x) {
      var parts = x.t.split(' / ');
      return others.every(function (o) { return parts.indexOf(o) > -1; });
    });
    if (!cands.length) return null;
    if (ci < 0) return cands[0];
    var pos = valuesFor(ci).indexOf(sel[ci]);
    return cands[Math.min(pos, cands.length - 1)];
  }

  /* ---------- center stone: "0.40 ct center stone (6 x 4 mm)" ---------- */
  var CN = Math.max(1, Math.round(+data.centerCount || 1)); // stones: 1 = center stone, 2+ = "5 blue sapphires"
  function centerParts(v) {
    if (!v || !$('[data-ts2-center]')) return null; // only where the line is enabled
    var g = (v.stones && v.stones.gem) || '';
    var ctRaw = (String(g).split('|')[1] || '').replace(/cts?/i, '').trim();
    var ct = parseFloat(ctRaw);
    var mmM = String(v.sku || '').match(/(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)mm/i) ||
              String(data.centerMm || '').match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
    var out = { ct: ct > 0 ? ct.toFixed(2) + ' ct' : '', mm: '' };
    if (mmM) {
      var a = +parseFloat(mmM[1]).toFixed(2), b = +parseFloat(mmM[2]).toFixed(2);
      if (a > 0) out.mm = (a === b || !(b > 0)) ? a + ' mm' : a + ' x ' + b + ' mm';
      // sanity check (same as the Liquid): one stone's carat must be 1/4x to 4x what a stone this size weighs
      if (out.ct && out.mm) {
        var bb = b > 0 ? b : a, est = a * bb * Math.min(a, bb) * 0.0061, each = ct / CN;
        if (each < est * 0.25 || each > est * 4) return null;
      }
    }
    return (out.ct || out.mm) ? out : null;
  }
  // 1 stone:  "0.40 ct center stone (6 x 4 mm)" / "0.40 ct center stone" / "6 x 4 mm center stone"
  // 2+ stones: "5 blue sapphires, 0.65 ct tw (3 mm each)" / "5 blue sapphires, 0.65 ct tw" / "5 blue sapphires (3 mm each)"
  // multi-stone pieces: weights only, "Blue Sapphire 0.65 ct tw · Diamond 0.60 ct tw" (no count, no mm)
  function multiWeights(v, p, sep) {
    if (!p.ct) return '';
    var out = (data.centerGem || 'Gemstone') + ' ' + p.ct + ' tw';
    var acc = parseFloat((String((v.stones && v.stones.accent) || '').split('|')[1] || '').replace(/cts?/i, '').trim());
    if (acc > 0 && data.accentName) out += sep + data.accentName + ' ' + acc.toFixed(2) + ' ct tw';
    return out;
  }
  function centerText(v) {
    var p = centerParts(v); if (!p) return '';
    if (CN > 1) return multiWeights(v, p, ' · ');
    return p.ct && p.mm ? p.ct + ' center stone (' + p.mm + ')' : (p.ct || p.mm) + ' center stone';
  }
  function centerDetail(v) {
    var p = centerParts(v); if (!p) return '';
    if (CN > 1) return multiWeights(v, p, ', ');
    return p.ct && p.mm ? p.ct + ' (' + p.mm + ')' : (p.ct || p.mm);
  }
  function showCenter(v, preview) {
    var cl = $('[data-ts2-center]'); if (!cl) return;
    var t = centerText(v);
    cl.textContent = t; cl.hidden = !t;
    cl.classList.toggle('is-preview', !!preview && v !== current);
  }

  /* ---------- render ---------- */
  function render(changed) {
    var v = current;
    // option rows: selected state, availability, prices on carat/chain chips
    $$('[data-ts2-options] .ts2-row').forEach(function (row) {
      var btns = $$('button[data-i]', row);
      if (!btns.length) return;
      var i = +btns[0].dataset.i;
      var pending = i === SIZE_I && !sizeChosen;
      row.querySelector('[data-cur]').textContent = pending ? 'Select your size' : nice(sel[i]);
      row.classList.toggle('is-pending', pending);
      btns.forEach(function (b) {
        var alt = variantWith(i, b.dataset.val);
        var on = !pending && b.dataset.val === sel[i];
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', String(on));
        b.classList.toggle('is-unavailable', !alt || !alt.available);
        var p = b.querySelector('[data-p]');
        if (p) p.textContent = alt ? money(alt.price) : '';
      });
    });
    $$('.ts2-fold[data-i]').forEach(function (fold) {
      var i = +fold.dataset.i, val = sel[i];
      fold.querySelector('[data-cur]').textContent = /no chain/i.test(val) ? 'Pendant only' : nice(val.replace(' / ', ', '));
      var base = V.filter(function (x) { return x.options.every(function (o, j) { return j === i || o === sel[j]; }); });
      // compare against the cheapest real choice ("No Chain" is a deduction, not the base)
      var real = base.filter(function (x) { return !/no chain/i.test(x.options[i]); });
      var cheapest = Math.min.apply(null, (real.length ? real : base).map(function (x) { return x.price; }));
      var sub = fold.querySelector('[data-sub]');
      var diff = v.price - cheapest;
      sub.textContent = diff === 0 ? 'Included' + (fold.dataset.kind === 'chain' && fold.dataset.combined ? ' · style, length or no chain' : '')
        : (diff > 0 ? '+' + money(diff) : '\u2212' + money(-diff) + (/no chain/i.test(val) ? ' · pendant without chain' : ''));
      $$('.ts2-subrow', fold).forEach(function (sr) {
        var role = sr.dataset.role;
        var cur = role === 'style' ? val.split(' / ')[0] : role === 'length' ? val.split(' / ')[1] : val;
        sr.hidden = role === 'length' && !cur;
        $$('.ts2-chip', sr).forEach(function (b) {
          var on = b.dataset.val === cur;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', String(on));
          var candidate = role === 'plain' ? variantWith(i, b.dataset.val) : null;
          var p = b.querySelector('[data-p]');
          // a chain this size doesn't come on (0.85mm on 1.53 / 2.53 ct) stays visible but greyed out
          var off = role === 'plain' && !candidate;
          b.classList.toggle('is-off', off);
          b.disabled = off;
          if (p) p.textContent = off ? 'Not for this size' : '';
          if (p && candidate) p.textContent = candidate.price === v.price ? '' : (candidate.price > v.price ? '+' : '−') + money(Math.abs(candidate.price - v.price));
        });
      });
    });

    // price, We make, manifest
    $$('[data-ts2-price],[data-ts2-atb-price],[data-ts2-manifest-price]').forEach(function (el) { el.textContent = money(v.price); });
    // center stone line under the title (follows the selected size)
    showCenter(v, false);
    setSpec('center', centerDetail(v));
    // free gift picker follows the price and metal (before the manifest, which includes the gift)
    if (window.TS2Gift) { var gmi = OPT.map(kind).indexOf('metal'); window.TS2Gift.update(v.price, gmi > -1 ? sel[gmi] : ''); }
    var m = manifest(v);
    var wm = $('[data-ts2-wemake]');
    wm.textContent = m ? 'What we make: ' + m.wm : '';
    var wml = $('[data-ts2-wemake-link]'); if (wml) wml.hidden = !m;
    var lines = $('[data-ts2-manifest-lines]');
    if (m) {
      // plain receipt: one line per cost (tap for details), what we make, your price
      lines.innerHTML = manifestCard(m, v);
      var skuEl = $('[data-ts2-mcard-sku]'); if (skuEl) skuEl.textContent = v.sku || '';
      $('.ts2-manifest').hidden = false;
    } else {
      $('.ts2-manifest').hidden = true;
    }

    // retail comparison (same fields as the current manifest: typical_online_retail, traditional_retailer_price)
    var r = v.retail || {}, cmp = $('[data-ts2-compare]');
    var ref = r.online > v.price ? [data.labels.typicalText || 'Typical online retail', r.online] : (r.traditional > v.price ? [data.labels.traditionalText || 'Traditional jeweler', r.traditional] : null);
    if (ref) {
      var save = ref[1] - v.price;
      cmp.innerHTML = '<span>' + esc(ref[0]) + ' <s>' + moneyRound(ref[1]) + '</s></span><strong>You save ' + moneyRound(save) + ' (' + Math.round(save * 100 / ref[1]) + '%)</strong>';
      cmp.hidden = false;
    } else cmp.hidden = true;
    // let other product-page sections (Beyond Compare) follow the selected variant
    document.dispatchEvent(new CustomEvent('ts2:variant', { detail: { id: v.id, sku: v.sku, price: v.price } }));

    // selected line + specs
    var parts = [];
    var gem = data.gemName || '';
    if (data.isShape) {
      // engagement rings: the "gemstone" field is the diamond shape
      var carT = data.caratWeight ? data.caratWeight + ' ct ' : '';
      parts.push(carT + gem + (/^emerald$/i.test(gem) ? '-cut' : '') + ' ' + (data.isLab ? 'Lab Diamond' : 'Diamond'));
    } else if (data.quality) {
      var q = data.quality;
      if (/^lab/i.test(q)) gem = gem.replace(/^lab[- ]grown\s+/i, '');
      parts.push((q + ' ' + gem).trim());
    } else if (gem) parts.push(gem);
    OPT.forEach(function (name, i) {
      var k = kind(name), val = sel[i];
      if (k === 'carat') parts.push(short(val, k) + ' ct');
      else if (k === 'size') { if (sizeChosen) parts.push('Size ' + val); }
      else if (k === 'chain') parts.push(/no chain/i.test(val) ? 'Pendant only' : val.replace(' / ', ', '));
      else parts.push(nice(val));
    });
    $('[data-ts2-selected]').textContent = parts.join(' · ');
    setSpec('carat', OPT.map(kind).indexOf('carat') > -1 ? short(sel[OPT.map(kind).indexOf('carat')], 'carat') + ' ct (approx.)' : '');
    setSpec('metal', OPT.map(kind).indexOf('metal') > -1 ? sel[OPT.map(kind).indexOf('metal')] : '');
    setSpec('weight', grams(v.metalWeight));
    var ci = OPT.map(kind).indexOf('chain');
    setSpec('chain', ci > -1 ? sel[ci].replace(' / ', ', ') : (v.chainType || ''));
    var bi = OPT.map(kind).indexOf('back');
    setSpec('back', bi > -1 ? sel[bi] : (v.backingType || ''));
    var accTxt = (v.accent || '').replace(/^[\s,]+|[\s,]+$/g, ''); if (/\d$/.test(accTxt)) accTxt += ' ct';
    setSpec('accent', /[a-z0-9]/i.test(accTxt) ? accTxt : '');
    $('[data-ts2-sku]').textContent = v.sku || '';

    // appraisal, availability
    var ap = $('[data-ts2-appraisal]');
    ap.textContent = v.price >= 200000 ? 'Free appraisal included' : 'Free appraisal on pieces $2,000+';
    ap.classList.toggle('is-on', v.price >= 200000);
    var label = $('[data-ts2-atb-label]');
    var atb = $('[data-ts2-atb]');
    atb.disabled = !v.available;
    label.textContent = v.available ? 'Add to Bag' : 'Unavailable';

    // installments widget
    var inst = document.querySelector('#ts2-installments-form input[name="id"]');
    if (inst && inst.value !== String(v.id)) { inst.value = v.id; inst.dispatchEvent(new Event('change', { bubbles: true })); }

    // sibling links keep the same carat / metal / size
    var sibs = data.siblings || {};
    $$('[data-ts2-sibling]').forEach(function (a) {
      var list = sibs[a.dataset.ts2Sibling];
      if (!list || !list.length) return;
      var hit = matchSibling(list);
      var base = a.getAttribute('href').split('?')[0];
      var view = new URLSearchParams(location.search).get('view');
      var qs = [];
      if (hit) qs.push('variant=' + hit.id);
      if (view) qs.push('view=' + encodeURIComponent(view));
      a.setAttribute('href', qs.length ? base + '?' + qs.join('&') : base);
    });

    if (changed) {
      var url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url.toString());
      updateGallery();
      fetchDelivery();
    }
  }
  function setSpec(key, val) {
    $$('[data-ts2-spec-dyn="' + key + '"]').forEach(function (el, idx) {
      el.hidden = !val;
      if (idx === 1) el.textContent = val;
    });
  }

  /* ---------- gallery (same AWS image service, matched by SKU) ---------- */
  var track = $('[data-ts2-track]');
  var thumbs = $('[data-ts2-thumbs]');
  var dots = $('[data-ts2-dots]');
  var mediaBtn = $('[data-ts2-mediabtn]');
  var shopifyImgs = $$('.ts2-slide:not([data-video]):not([data-pack]) img', track).map(function (img) { return { src: img.currentSrc || img.src, srcset: img.getAttribute('srcset'), alt: img.getAttribute('alt') || '' }; });
  /* keyword alt text rendered by the theme (snippets/ts-img-alt): keep it when the photos are redrawn
     for another SKU, by file name when it is the same photo, else by photo number with the metal of
     the chosen option swapped in */
  var altByName = {}, altByPos = shopifyImgs.map(function (x) { return x.alt; });
  shopifyImgs.forEach(function (x) { if (x.alt) altByName[String(x.src).split('?')[0].split('/').pop().toLowerCase()] = x.alt; });
  var METAL_RE = /\b(?:(?:10|14|18|22)k )?(?:white|yellow|rose|blackened) gold\b|\bplatinum\b|\bsterling silver\b/i;
  function variantMetal() {
    var c = (current.sku || '').match(/_(10|14|18|22)K([WYRB])\b/i);
    if (c) return c[1] + 'k ' + ({ w: 'white', y: 'yellow', r: 'rose', b: 'blackened' })[c[2].toLowerCase()] + ' gold';
    var txt = ((current.options || []).join(' ') + ' ' + (current.title || '')).toLowerCase();
    var m = txt.match(/\b(10|14|18|22)\s*k\b[^,/]*?\b(white|yellow|rose|black(?:ened)?)\b/);
    if (m) return m[1] + 'k ' + (m[2].indexOf('black') === 0 ? 'blackened' : m[2]) + ' gold';
    m = txt.match(/\b(white|yellow|rose|blackened|black) gold\b/);
    if (m) return (m[1] === 'black' ? 'blackened' : m[1]) + ' gold';
    if (/platinum/.test(txt)) return 'platinum';
    if (/silver/.test(txt)) return 'sterling silver';
    return '';
  }
  function altFor(s, i) {
    var name = String(s.src).split('?')[0].split('/').pop().toLowerCase();
    var a = s.alt || altByName[name];
    if (!a) {
      var pos = (s.n || i + 1) - 1;
      a = altByPos[pos] || (altByPos[0] ? altByPos[0] + ', view ' + (pos + 1) : '');
      var mt = variantMetal();
      if (a && mt) a = METAL_RE.test(a) ? a.replace(METAL_RE, mt) : a;
    }
    if (a && s.model && !/model/i.test(a)) a += ', worn on model';
    return a || '';
  }
  var videoSlides = $$('.ts2-slide[data-video]', track).map(function (el) { return el.outerHTML; });
  var videoThumbs = $$('.ts2-thumb[data-video]', thumbs).map(function (el) { return el.outerHTML; });
  var packSlide = $('.ts2-slide[data-pack]', track), packThumb = $('.ts2-thumb[data-pack]', thumbs);
  packSlide = packSlide ? packSlide.outerHTML : ''; packThumb = packThumb ? packThumb.outerHTML : '';
  var PLAY_ICON = '<svg class="ts2-play" width="22" height="22" viewBox="0 0 22 22" aria-hidden="true"><circle cx="11" cy="11" r="10" fill="rgba(255,255,255,.9)"/><path d="M9 7v8l6-4z" fill="#141414"/></svg>';
  var awsList = null;
  var modelUrl = null; // a Shopify product photo detected as an on-model shot
  function skuKey() {
    var s = (current.sku || '').toLowerCase().replace(/-ch\d+$/, ''); // chain variants (-CH085) share the photos of the base SKU
    if (/^rings/i.test(data.type || '')) s = s.split('-')[0];
    return s;
  }
  function skuRe(ext) { return new RegExp('/' + skuKey().replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '-(\\d+)\\.(' + ext + ')$', 'i'); }
  /* Shopify-hosted photos named by SKU (MYSP201_BSAPP_5mm_G_14KY-1_<uuid>.png), used when AWS has none */
  var shopAll = (data.media || []).filter(function (u) { return !/packaging/i.test(u); });
  function shopName(u) { return String(u).split('?')[0].split('/').pop(); }
  /* SEO-named product angles: <name>-<stone>-...-<metal>-<setting>-<view>.jpg (view list from the catalog) */
  var SEO_VIEW_RE = /[-_](?:front|side|(?:side[-_])?slant|side[-_]straight|side[-_]view|coin|hand|side[-_]hand|hand[-_]second|second[-_]hand|angle)(?:_[0-9a-f-]{20,})?\.(?:png|jpe?g|webp)$/i;
  /* empty white placeholder some listings carry (blank_image.jpg): never a slide */
  function isBlank(u) { return /^blank_image(?:_[0-9a-f-]{20,})?\.(?:png|jpe?g|webp)$/i.test(shopName(u)); }
  function shopRe(key) { return new RegExp('^' + key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '-(\\d+)(?:_[0-9a-f-]{20,})?\\.(?:png|jpe?g|webp)$', 'i'); }
  function shopSet(u) { return [600, 1000, 1400].map(function (w) { return u.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'; }).join(', '); }
  function shopHits(key) {
    var re = shopRe(key);
    return shopAll.map(function (u) { var mm = shopName(u).match(re); return mm ? { src: u, srcset: shopSet(u), n: +mm[1] } : null; })
      .filter(Boolean).sort(function (a, b) { return a.n - b.n; });
  }
  function slideHTML(s, i) {
    return '<div class="ts2-slide"' + (s.model ? ' data-model' : '') + '><img src="' + esc(s.src) + '"' + (s.srcset ? ' srcset="' + esc(s.srcset) + '" sizes="(min-width: 990px) 50vw, 100vw"' : '') + ' alt="' + esc(altFor(s, i)) + '" width="1000" height="1000"' + (i ? ' loading="lazy"' : ' fetchpriority="high"') + '></div>';
  }
  function thumbHTML(s, i) {
    return '<button type="button" class="ts2-thumb' + (i ? '' : ' is-active') + '" data-index="' + i + '" aria-label="Photo ' + (i + 1) + '"><img src="' + esc(s.src) + '" alt="" width="80" height="80" loading="lazy"></button>';
  }
  function updateGallery() {
    // changing carat / metal / size redraws the photos for the new SKU: stay on the same view
    // (on-model stays on-model, so the shopper can compare sizes on the model)
    var prevI = track.children.length ? activeIndex() : 0;
    var prev = track.children.length ? { v: slideKey(track.children[prevI]), i: prevI } : null;
    var slides = null;
    if (awsList) {
      var re = skuRe('png|jpe?g|webp');
      var hits = awsList.map(function (u) { var mm = u.match(re); return mm ? { src: u, n: +mm[1] } : null; })
        .filter(Boolean).sort(function (a, b) { return a.n - b.n; });
      if (hits.length) {
        var prefix = (current.sku || '').split('_')[0].toLowerCase();
        // Shopify photos AWS doesn't have (the Transparency Manifest card and the like) are added after
        // the AWS ones. Photos renamed for SEO (camille-emerald-...-rose-gold-prong-front.jpg) are the
        // same product angles AWS already has for every metal, so they are not added again.
        var extras = shopifyImgs.filter(function (x) { return prefix && x.src.toLowerCase().indexOf(prefix) < 0 && !SEO_VIEW_RE.test(shopName(x.src)) && !isBlank(x.src); });
        slides = hits.concat(extras);
      }
    }
    if (!slides) {
      var sh = shopHits(skuKey());
      if (sh.length) {
        var pre = (current.sku || '').split('_')[0].toLowerCase() + '_';
        var others = shopAll.filter(function (u) { return shopName(u).toLowerCase().indexOf(pre) !== 0 && !isBlank(u); })
          .map(function (u) { return { src: u, srcset: shopSet(u) }; });
        slides = sh.concat(others).slice(0, 8);
      }
    }
    if (!slides) slides = shopifyImgs.filter(function (x) { return !isBlank(x.src); });
    if (!slides.length) slides = shopifyImgs.slice(); // never leave the gallery empty
    // on-model photo: the same photo number for this SKU on AWS, else the Shopify photo itself
    if (modelUrl) {
      var mName = modelUrl.split('/').pop().split('?')[0];
      var mNum = (mName.match(/-(\d+)(?:_[0-9a-f-]{20,})?\.(?:jpe?g|png|webp)$/i) || [])[1];
      var mPre = mName.replace(/-(\d+)(?:_[0-9a-f-]{20,})?\.(?:jpe?g|png|webp)$/i, '').toLowerCase();
      var base = (current.sku || '').toLowerCase().replace(/_[0-9]*k[a-z]*$/i, '');
      var mapped = null;
      if (mNum && mPre.indexOf('_') > -1 && base && mPre.indexOf(base.split('_')[0]) === 0) mapped = slides.filter(function (s) { return s.n === +mNum; })[0];
      // a photo renamed for SEO (camille-...-hand.jpg) keeps its place in the product's photo order, which
      // is the AWS photo number: show this metal's AWS copy instead of adding the renamed one again
      if (!mapped && !mNum && SEO_VIEW_RE.test(mName)) {
        var seoPos = shopAll.map(shopName).indexOf(mName);
        if (seoPos > -1) mapped = slides.filter(function (s) { return s.n === seoPos + 1; })[0];
      }
      if (mapped) mapped.model = true;
      else {
        var same = slides.filter(function (s) { return s.src.split('?')[0].split('/').pop() === mName; })[0];
        if (same) same.model = true; else slides.push({ src: modelUrl, model: true });
      }
    }
    track.innerHTML = slides.map(slideHTML).join('');
    thumbs.innerHTML = slides.map(thumbHTML).join('');
    var n = slides.length;
    // videos: this SKU's own video on AWS if there is one, else the Shopify product video(s)
    var awsVid = awsList ? awsList.filter(function (u) { return skuRe('mp4').test(u); })[0] : null;
    if (awsVid) {
      track.insertAdjacentHTML('beforeend', '<div class="ts2-slide ts2-slide--video" data-video><video src="' + esc(awsVid) + '" muted loop playsinline preload="none" poster="' + esc(slides[0] ? slides[0].src : '') + '"></video></div>');
      thumbs.insertAdjacentHTML('beforeend', '<button type="button" class="ts2-thumb ts2-thumb--video" data-video data-index="' + n + '" aria-label="Video">' + (slides[0] ? '<img src="' + esc(slides[0].src) + '" alt="" width="80" height="80" loading="lazy">' : '') + PLAY_ICON + '</button>');
      n++;
    } else if (videoSlides.length) {
      track.insertAdjacentHTML('beforeend', videoSlides.join('').replace(/ data-ts-seen=""/g, ''));
      var n0 = n;
      thumbs.insertAdjacentHTML('beforeend', videoThumbs.map(function (h, k) { return h.replace(/data-index="\d+"/, 'data-index="' + (n0 + k) + '"').replace(' is-active', ''); }).join(''));
      n += videoSlides.length;
      if (window.__tsPdpVideo) window.__tsPdpVideo();
    }
    // packaging for this kind of jewelry, always last
    if (packSlide) {
      track.insertAdjacentHTML('beforeend', packSlide);
      thumbs.insertAdjacentHTML('beforeend', packThumb.replace(/data-index="\d+"/, 'data-index="' + n + '"').replace(' is-active', ''));
    }
    // the photo the shopper is on now wins. Right after arriving from another quality/stone, the carried
    // view also counts: iPhone Safari can report the photo strip at photo 1 for a moment while the new
    // product sets up. The carried view is dropped as soon as the shopper moves the photos themselves.
    var kept = (prev && prev.i > 0 && showView(prev)) || showCarried();
    if (!kept) track.scrollLeft = 0;
    buildDots();
    mediaButton();
    if (kept) track.dispatchEvent(new Event('scroll')); // dots were just rebuilt on photo 1
  }
  /* "Watch video" if there is a video, else "See it on model" if a model photo exists */
  var PLAY = '<svg width="14" height="14" viewBox="0 0 22 22" aria-hidden="true"><circle cx="11" cy="11" r="10" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M9 7v8l6-4z" fill="currentColor"/></svg>';
  function mediaButton() {
    var slides = $$('.ts2-slide', track), target = -1, label = '';
    slides.forEach(function (sl, i) { if (target < 0 && sl.hasAttribute('data-video')) { target = i; label = PLAY + '<span>Watch video</span>'; } });
    if (target < 0) slides.forEach(function (sl, i) { if (target < 0 && sl.hasAttribute('data-model')) { target = i; label = '<span>See it on model</span>'; } });
    if (target < 0) { mediaBtn.hidden = true; return; }
    mediaBtn.innerHTML = label; mediaBtn.dataset.index = target; mediaBtn.hidden = false;
    mediaBtn.classList.toggle('is-here', activeIndex() === target);
  }
  function goTo(i, smooth) { viewGen++; track.scrollTo({ left: track.clientWidth * i, behavior: smooth ? 'smooth' : 'auto' }); }
  mediaBtn.addEventListener('click', function () { goTo(+mediaBtn.dataset.index, true); });
  // desktop: size thumbnails so all of them fit beside the main image (no scrollbar)
  function fitThumbs() {
    var main = $('.ts2-gallery__main'); if (!main || window.innerWidth < 990) return;
    var n = thumbs.children.length; if (!n) return;
    var h = main.getBoundingClientRect().height, gap = 8;
    var size = Math.max(44, Math.min(72, Math.floor((h - gap * (n - 1)) / n)));
    $('.ts2-gallery').style.setProperty('--ts2-th', size + 'px');
  }
  __ts2Life.on(window, 'resize', fitThumbs);
  function buildDots() {
    fitThumbs();
    var n = track.children.length;
    dots.innerHTML = '';
    for (var i = 0; i < n; i++) { var d = document.createElement('span'); if (!i) d.className = 'is-active'; dots.appendChild(d); }
  }
  function activeIndex() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
  var lastActive = 0;
  track.addEventListener('scroll', function () {
    var i = activeIndex();
    $$('span', dots).forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
    $$('.ts2-thumb', thumbs).forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
    if (mediaBtn.dataset.index) mediaBtn.classList.toggle('is-here', i === +mediaBtn.dataset.index);
    if (i !== lastActive) {
      lastActive = i;
      // AWS videos play only while they are the slide on screen
      $$('.ts2-slide video:not(.ts-pdp-video)', track).forEach(function (v, k) {
        if (v.closest('.ts2-slide') === track.children[i]) { try { v.play(); } catch (e) {} } else { try { v.pause(); } catch (e) {} }
      });
    }
  }, { passive: true });
  // desktop: hovering a thumbnail shows that photo/video in the main image
  thumbs.addEventListener('mouseover', function (e) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var b = e.target.closest('.ts2-thumb'); if (!b) return;
    goTo(+b.dataset.index, false);
  });
  thumbs.addEventListener('click', function (e) {
    var b = e.target.closest('.ts2-thumb'); if (!b) return;
    goTo(+b.dataset.index, true);
  });
  buildDots();
  mediaButton();
  fetch('https://1yi00t63hl.execute-api.us-east-1.amazonaws.com/v1/' + data.productId)
    .then(function (r) { return r.json(); })
    .then(function (list) { if (Array.isArray(list)) { awsList = list; updateGallery(); } })
    .catch(function () {});

  /* on-model photo detection: product shots sit on white, model shots don't.
     Reads a 24px copy of each Shopify product photo (Shopify's CDN allows this). */
  (function detectModel() {
    var urls = (data.media || []).filter(function (u) { return !/packaging/i.test(u); });
    if (!urls.length) return;
    var k = 0;
    function next() {
      if (k >= urls.length || modelUrl) return;
      var u = urls[k++], im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var c = document.createElement('canvas'); c.width = c.height = 24;
          var x = c.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, 24, 24); x.drawImage(im, 0, 0, 24, 24); // transparent PNGs count as white
          var d = x.getImageData(0, 0, 24, 24).data, w = 0, n = 0;
          for (var y = 0; y < 24; y++) for (var xx = 0; xx < 24; xx++) {
            if (y > 1 && y < 22 && xx > 1 && xx < 22) continue;
            var p = (y * 24 + xx) * 4; if ((d[p] + d[p + 1] + d[p + 2]) / 3 > 225) w++; n++;
          }
          if (w / n < 0.45) { modelUrl = u; updateGallery(); return; }
        } catch (e) {}
        next();
      };
      im.onerror = next;
      im.src = u.replace(/width=\d+/, 'width=48');
    }
    if ('requestIdleCallback' in window) requestIdleCallback(next); else setTimeout(next, 800);
  })();

  /* ---------- delivery (same inventory service + ts2DateDelivery copied from the current page) ---------- */
  function fetchDelivery() {
    if (typeof window.ts2DateDelivery !== 'function') return;
    fetch('https://truesaniti.com/truesanity/product_inventory.php', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productData: [{ vid: current.id, pid: data.productId }] })
    }).then(function (r) { return r.json(); }).then(function (txt) {
      var o = typeof txt === 'string' ? JSON.parse(txt) : txt;
      try { window.ts2DateDelivery(o.inventory_qty, o.quantity_more_than_1_ship_time, o.quantity_less_than_1_ship_time, o.price); } catch (e) {}
      $('[data-ts2-atb]').disabled = !current.available;
    }).catch(function () {
      try { window.ts2DateDelivery(0, undefined, undefined, current.price / 100); } catch (e) {}
    });
  }

  /* ---------- US vs international wording ---------- */
  function applyCountry() {
    var us = isUS();
    $('[data-ts2-returns-text]').textContent = us ? 'Free 45-day returns · Free shipping both ways' : '45-day returns';
    $('[data-ts2-ship-line]').textContent = us ? 'Free shipping both ways'
      : (current.price >= 200000 ? 'Free international shipping' : 'Shipping calculated at checkout · Free over $2,000');
    $('[data-ts2-duties]').hidden = us;
    $$('[data-ts2-policy-us]').forEach(function (el) { el.hidden = !us; });
    $$('[data-ts2-policy-intl]').forEach(function (el) { el.hidden = us; });

  }
  // the Delivery & Returns section repeats the live delivery date from the box above
  (function () {
    var dd = document.getElementById('est_delivery_date'), dl = $('[data-ts2-acc-delivery]');
    if (!dd || !dl) return;
    var copy = function () { var t = dd.textContent.replace(/\s+/g, ' ').trim(); if (t) dl.textContent = 'Order today, arrives by ' + t + '.'; };
    copy();
    if ('MutationObserver' in window) __ts2Life.watch(new MutationObserver(copy)).observe(dd, { childList: true, characterData: true, subtree: true });
  })();
  var countryTries = 0;
  var countryTimer = __ts2Life.every(setInterval(function () { applyCountry(); if (++countryTries > 10) clearInterval(countryTimer); }, 800));

  /* ---------- review stars ----------
     The chip near the title is drawn by the theme from the product's review metafields
     (snippets/ts-review-chip, kept current by Klaviyo Reviews): shown only when there are reviews.
     Point it at the reviews section, and hide that section when there is nothing to show. */
  var reviewsSection = document.querySelector('[id$="__reviews"]');
  var ratingChip = $('[data-ts2-rating]');
  if (reviewsSection && ratingChip) ratingChip.setAttribute('href', '#' + reviewsSection.id);
  if (reviewsSection && (!ratingChip || ratingChip.hidden)) reviewsSection.hidden = true;

  /* ---------- engraving (existing modal in assets/global.js) ---------- */
  var engraving = null;
  var engBox = $('[data-ts2-engrave]');
  if (engBox) {
    engBox.querySelector('[data-ts2-engrave-open]').addEventListener('click', function () {
      var a = document.getElementById('engraving-open-modal'); if (a) a.click();
    });
    if (window.emitter && window.emitter.on) {
      window.emitter.on('engraveChange', function (vals) {
        engraving = vals;
        var t = [vals.engraveText, vals.engraveBackText].filter(function (x) { return x && x.trim(); }).join(' / ');
        engBox.querySelector('[data-ts2-engrave-label]').textContent = t ? '“' + t.trim() + '”' : 'None';
        var es = engBox.querySelector('[data-ts2-engrave-sub]');
        if (es) es.textContent = t ? '+' + money(data.engraving.price) + ' added · engraved pieces are final sale' : 'Add a message · +' + money(data.engraving.price);
        engBox.querySelector('.ts2-fold__cta').textContent = t ? 'Edit' : 'Add';
      });
    }
  }

  /* ---------- add to bag (same line-item properties as the current page) ---------- */
  function addToBag() {
    var v = current; if (!v.available) return;
    if (DEMO) { var de = $('[data-ts2-error]'); if (de) { de.textContent = 'Preview demo: sample chain options, Add to Bag is off.'; de.hidden = false; } return; }
    if (!sizeChosen) {
      // rings: ask for the size instead of adding a guessed one
      var srow = $$('[data-ts2-options] .ts2-row').filter(function (r) { var b = r.querySelector('button[data-i]'); return b && +b.dataset.i === SIZE_I; })[0];
      var err = $('[data-ts2-size-error]');
      if (srow && err) { srow.appendChild(err); err.hidden = false; }
      if (srow) scrollToEl(srow);
      return;
    }
    var btns = $$('[data-ts2-atb],[data-ts2-atb-sticky]');
    btns.forEach(function (b) { b.disabled = true; b.classList.add('is-loading'); });
    var props = {};
    var dd = document.getElementById('delivery_date');
    props._Delivery = dd ? dd.value : '';
    var first = track.querySelector('img');
    props._selectedImage = first ? first.src : '';
    var sp = document.getElementById('special_ocassion_id');
    props._special = sp ? sp.value : '';
    props.Sku = v.sku;
    props._caratWeight = data.caratWeight == null ? '' : String(data.caratWeight);
    var si = OPT.map(kind).indexOf('size');
    if (si > -1) props.Size = sel[si];
    var items = [];
    if (engraving && data.engraving && (engraving.engraveText || '').trim()) {
      var rnd = (Math.random().toString(36) + '00000000000000000').slice(2, 12);
      props._rendom_no = rnd; props._engrave_product = 'true';
      items.push({ id: data.engraving.id, quantity: 1, properties: {
        'option-engrave': String(data.engraving.id), _rendom_no: rnd, _engrave: true,
        'Engrave Front Font': engraving.engraveFont, 'Engrave Back Font': engraving.engraveBackFont,
        'Engrave Front Text': engraving.engraveText, 'Engrave Back Text': engraving.engraveBackText } });
    }
    items.push({ id: v.id, quantity: 1, properties: props });
    // free gift chosen under Add to Bag goes in with the piece (replacing an older gift in the bag)
    var giftStep = window.TS2Gift ? window.TS2Gift.prepareAdd().catch(function () { return null; }) : Promise.resolve(null);
    giftStep.then(function (gift) {
      if (gift) items.push(gift);
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add to bag');
        try { localStorage.removeItem('EngraveEnable'); } catch (e) {}
        if (window.gtag) { try { gtag('event', 'add_to_cart', { currency: 'USD', value: v.price / 100, items: [{ item_id: v.sku, price: v.price / 100 }] }); } catch (e) {} }
        // the bag page sends Klaviyo "Added to Cart" for this piece (sending it here would be cut off by the redirect)
        try {
          var line = ((res.j && res.j.items) || []).filter(function (i) { return i.variant_id === v.id; })[0];
          if (line) { var pend = {}; pend[line.key] = 1; sessionStorage.setItem('ts_kl_added', JSON.stringify(pend)); }
        } catch (e) {}
        window.location.href = '/cart';
      })
      .catch(function (err) {
        var e = $('[data-ts2-error]'); e.textContent = err.message; e.hidden = false;
        btns.forEach(function (b) { b.disabled = false; b.classList.remove('is-loading'); });
      });
  }
  $('[data-ts2-atb]').addEventListener('click', addToBag);
  $('[data-ts2-atb-sticky]').addEventListener('click', addToBag);

  /* ---------- sticky bar: only after the main button scrolls away ---------- */
  var sticky = $('[data-ts2-sticky]'), atbWrap = $('[data-ts2-atb-wrap]'), stickyOn = null;
  function updateSticky() {
    var hidden = atbWrap.getBoundingClientRect().bottom < 0; // main button has scrolled up out of view
    // Shopify's preview banner sits on the bottom edge on preview links; sit above it
    var pb = document.getElementById('PBarNextFrameWrapper');
    var lift = pb && getComputedStyle(pb).display !== 'none' ? Math.max(0, innerHeight - pb.getBoundingClientRect().top) : 0;
    sticky.style.bottom = lift ? lift + 'px' : '';
    document.documentElement.style.setProperty('--ts2-lift', lift + 'px');
    if (hidden === stickyOn) return;
    stickyOn = hidden;
    sticky.classList.toggle('is-on', hidden);
    sticky.setAttribute('aria-hidden', String(!hidden));
    $('[data-ts2-atb-sticky]').tabIndex = hidden ? 0 : -1;
    document.documentElement.classList.toggle('ts2-sticky-on', hidden);
  }
  __ts2Life.on(window, 'scroll', updateSticky, { passive: true });
  __ts2Life.on(window, 'resize', updateSticky);
  updateSticky();

  /* ---------- drop a hint / help / manifest ---------- */
  $$('[data-ts2-hint]').forEach(function (hb) { hb.addEventListener('click', function () {
    var url = location.origin + location.pathname + '?variant=' + current.id;
    var text = 'I have been looking at this: ' + document.title.split('|')[0].trim();
    if (navigator.share) { navigator.share({ title: 'A hint', text: text, url: url }).catch(function () {}); return; }
    location.href = 'mailto:?subject=' + encodeURIComponent('A little hint') + '&body=' + encodeURIComponent(text + '\n\n' + url);
  }); });
  var mail = $('[data-ts2-mail]');
  if (mail) mail.addEventListener('click', function () {
    var body = 'Question about: ' + document.title.split('|')[0].trim() + '\nSelected: ' + $('[data-ts2-selected]').textContent + '\nSKU: ' + current.sku + '\n' + location.href + '\n\n';
    mail.setAttribute('href', mail.getAttribute('href').split('?')[0] + '?subject=' + encodeURIComponent('Question about ' + current.sku) + '&body=' + encodeURIComponent(body));
  });
  $('[data-ts2-chat]').addEventListener('click', function () {
    var l = document.getElementById('ts-chat-launcher');
    if (l && l.getAttribute('data-state') !== 'loaded') { l.click(); return; }
    try { window.GorgiasChat && window.GorgiasChat.open(); } catch (e) {}
  });
  // land the target just under the sticky site header (and re-check once lazy content above has settled)
  function headerOffset() {
    var off = 0;
    $$('sticky-header, .shopify-section-header-sticky, .section-header, header').forEach(function (h) {
      var cs = getComputedStyle(h), r = h.getBoundingClientRect();
      if ((cs.position === 'fixed' || cs.position === 'sticky') && r.top <= 1 && r.bottom > off && r.height < 260) off = r.bottom;
    });
    var hdr = document.querySelector('sticky-header, .shopify-section-header-sticky');
    if (!off && hdr) off = Math.min(hdr.getBoundingClientRect().height, 160); // header turns sticky once you scroll
    return off + 12;
  }
  function scrollToEl(t) {
    var target = function () { return Math.max(0, t.getBoundingClientRect().top + window.pageYOffset - headerOffset()); };
    window.scrollTo({ top: target(), behavior: 'smooth' });
    // once the smooth scroll has finished, nudge to the exact spot if anything above moved
    var done = false;
    function fix() {
      if (done) return; done = true;
      var d = t.getBoundingClientRect().top - headerOffset();
      if (Math.abs(d) > 6) {
        var h = document.documentElement, sb = h.style.scrollBehavior;
        h.style.scrollBehavior = 'auto';
        window.scrollTo(0, window.pageYOffset + d);
        h.style.scrollBehavior = sb;
      }
    }
    if ('onscrollend' in window) __ts2Life.on(window, 'scrollend', fix, { once: true });
    else setTimeout(fix, 1200);
  }
  $$('[data-ts2-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.getElementById(a.getAttribute('href').slice(1)); if (!t) return;
      e.preventDefault(); e.stopPropagation();
      scrollToEl(t);
    });
  });
  // center gemstone: "+N more" opens the rest of this piece's group; "Also available ..." opens the other group
  $$('[data-ts2-gemrow]').forEach(function (row) {
    var mine = row.querySelector('[data-ts2-gempanel="mine"]');
    var other = row.querySelector('[data-ts2-gempanel="other"]');
    row.classList.add('ts2-gemrow');
    row.addEventListener('click', function (e) {
      if (e.target.closest('[data-ts2-gemmore]') && mine) {
        mine.hidden = false; row.classList.add('is-open');
        return;
      }
      if (e.target.closest('[data-ts2-gemless]') && mine) {
        mine.hidden = true; row.classList.remove('is-open');
        scrollToEl(row);
        return;
      }
      var ob = e.target.closest('[data-ts2-gemother]');
      if (ob && other) {
        var open = other.hidden;
        other.hidden = !open;
        ob.setAttribute('aria-expanded', String(open));
      }
    });
  });
  var dlg = $('[data-ts2-dialog]');
  __ts2Life.on(document, 'click', function (e) {
    var b = e.target.closest('[data-ts2-sizechart]'); if (!b) return;
    var tpl = $('[data-ts2-sizechart-tpl]'); if (!tpl || !dlg) return;
    $('[data-ts2-dialog-body]').innerHTML = '<div class="ts2-sizechart">' + tpl.innerHTML + '</div>';
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  });
  $('[data-ts2-manifest-full]').addEventListener('click', function () {
    var body = $('[data-ts2-dialog-body]');
    body.innerHTML = '<p class="ts2-muted">Loading the manifest…</p>';
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    fetch(location.pathname + '?variant=' + current.id + '&section_id=pdp-manifest-v2')
      .then(function (r) { return r.text(); })
      .then(function (html) { body.innerHTML = html; })
      .catch(function () { body.innerHTML = '<p>Could not load the manifest. Please try again.</p>'; });
  });
  $('[data-ts2-dialog-close]').addEventListener('click', function () { dlg.close ? dlg.close() : dlg.removeAttribute('open'); });

  $('[data-ts2-manifest-lines]').addEventListener('toggle', function (e) {
    var d = e.target; if (d && d.dataset && d.dataset.key) openLines[d.dataset.key] = d.open;
    if (d && d.classList && d.classList.contains('ts2-mfull')) openLines.__full = d.open;
  }, true);

  __ts2Life.on(window, 'ts:promo', function () { try { render(); } catch (e) {} });

  /* ---------- hover preview of price: the price shows what you'd pay for the option under the mouse ---------- */
  var priceTimer = null;
  function previewPrice(cents) {
    if (cents == null) return;
    clearTimeout(priceTimer);
    $$('[data-ts2-price]').forEach(function (el) { el.textContent = money(cents); el.classList.toggle('is-preview', cents !== current.price); });
    var wm = $('[data-ts2-wemake-link]'); if (wm) wm.classList.toggle('is-preview', cents !== current.price);
  }
  function endPreviewPrice() {
    clearTimeout(priceTimer);
    priceTimer = setTimeout(function () {
      $$('[data-ts2-price]').forEach(function (el) { el.textContent = money(current.price); el.classList.remove('is-preview'); });
      var wm = $('[data-ts2-wemake-link]'); if (wm) wm.classList.remove('is-preview');
      showCenter(current, false);
    }, 120);
  }

  /* ---------- hover preview: metal and carat show that variant's photo (mouse only) ---------- */
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var hoverTimer = null, restoreSrc = null;
    // that variant's photo for view number n (1 = front, 3 = on model ...)
    function photoFor(v, n) {
      n = n || 1;
      var key = (v.sku || '').toLowerCase();
      if (/^rings/i.test(data.type || '')) key = key.split('-')[0];
      var re = new RegExp('/' + key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '-' + n + '\\.(png|jpe?g|webp)$', 'i');
      var a = awsList ? awsList.filter(function (u) { return re.test(u); })[0] : null;
      if (a) return a;
      var sh = shopHits(key).filter(function (h) { return h.n === n; })[0];
      return sh ? sh.src : null;
    }
    optWrap.addEventListener('mouseover', function (e) {
      var b = e.target.closest('button[data-i]'); if (!b) return;
      var alt = variantWith(+b.dataset.i, b.dataset.val); if (!alt) return;
      previewPrice(alt.price);
      showCenter(alt, true);
      var k = kind(OPT[+b.dataset.i]); if (k !== 'metal' && k !== 'carat') return;
      // preview on the photo the shopper is looking at (on-model stays on-model), else the front photo
      var ai = restoreSrc ? Math.round(restoreSrc.left / Math.max(1, track.clientWidth)) : activeIndex();
      var slide = track.children[ai], key = slideKey(slide);
      var vn = key && key.kind === 'n' ? key.n : 0;
      if (!vn && key && key.kind === 'model') { var mm = slide.querySelector('img'); vn = mm ? (shopName(mm.getAttribute('src')).match(/-(\d+)(?:_[0-9a-f-]{20,})?\.(?:png|jpe?g|webp)$/i) || [])[1] : 0; vn = +vn || 0; }
      var src = vn ? photoFor(alt, vn) : null;
      var img;
      if (src) img = slide.querySelector('img');
      else { src = photoFor(alt, 1); img = track.querySelector('.ts2-slide img'); }
      if (!src || !img) return;
      clearTimeout(hoverTimer);
      if (restoreSrc !== null && restoreSrc.img !== img) {
        // moved to an option previewed on a different photo: put the previous one back first
        restoreSrc.img.src = restoreSrc.src; if (restoreSrc.srcset) restoreSrc.img.setAttribute('srcset', restoreSrc.srcset);
        track.scrollLeft = restoreSrc.left; restoreSrc = null;
      }
      if (restoreSrc === null) restoreSrc = { img: img, src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), left: track.scrollLeft };
      img.removeAttribute('srcset');
      img.src = src;
      if (img === track.querySelector('.ts2-slide img')) track.scrollLeft = 0;
    });
    optWrap.addEventListener('mouseout', function (e) {
      var b = e.target.closest('button[data-i]'); if (!b || b.contains(e.relatedTarget)) return;
      endPreviewPrice();
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () {
        if (restoreSrc === null) return;
        var img = restoreSrc.img;
        if (img) { img.src = restoreSrc.src; if (restoreSrc.srcset) img.setAttribute('srcset', restoreSrc.srcset); }
        track.scrollLeft = restoreSrc.left;
        restoreSrc = null;
      }, 120);
    });
    // clicking: put the shopper's view back first, so the redraw for the new variant keeps it
    optWrap.addEventListener('click', function () {
      if (restoreSrc !== null) { track.scrollLeft = restoreSrc.left; restoreSrc = null; }
    }, true);
  }

  /* ---------- hover preview: gemstone + quality siblings (same CloudFront photo path as the current page) ---------- */
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var sibRestore = null, sibTimer = null, sibCache = {};
    // photo number n (1 = front, 3 = on model ...) of a sibling quality / stone, same carat + metal
    function sibPhoto(handle, n, cb) {
      var list = (data.siblings || {})[handle];
      if (!list || !list.length) return;
      var hit = matchSibling(list) || list[0];
      if (!hit || !hit.s) return;
      var skuBase = /^rings/i.test(data.type || '') ? String(hit.s).split('-')[0] : hit.s; // ring SKUs end in the size
      var base = 'https://dsv7iunirnrax.cloudfront.net/' + hit.p + '/' + skuBase + '-' + n + '.';
      if (sibCache[base] !== undefined) { if (sibCache[base]) cb(sibCache[base]); else if (n !== 1) sibPhoto(handle, 1, cb); return; }
      var tryExt = function (exts) {
        if (!exts.length) {
          shopSibPhoto(handle, skuBase, n, function (src) {
            sibCache[base] = src || '';
            if (src) cb(src); else if (n !== 1) sibPhoto(handle, 1, cb);   // no such view: front photo
          });
          return;
        }
        var im = new Image();
        im.onload = function () { sibCache[base] = im.src; cb(im.src); };
        im.onerror = function () { tryExt(exts.slice(1)); };
        im.src = base + exts[0];
      };
      tryExt(['png', 'jpg']);
    }
    /* no AWS photo: use the sibling's own Shopify photo named <SKU>-<n> (e.g. MYSP202_BSAPP_5mm_F_14KY-3.png) */
    var sibImgs = {};
    function shopSibPhoto(handle, skuBase, n, cb) {
      if (!sibImgs[handle]) {
        sibImgs[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { return p && Array.isArray(p.images) ? p.images : []; })
          .catch(function () { return []; });
      }
      sibImgs[handle].then(function (imgs) {
        var re = shopRe(String(skuBase).toLowerCase());
        var u = imgs.filter(function (x) { return re.test(shopName(x)) && shopName(x).match(re)[1] === String(n); })[0];
        if (!u) { cb(null); return; }
        if (u.indexOf('//') === 0) u = 'https:' + u;
        var src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=1000';
        var im = new Image();
        im.onload = function () { cb(src); };
        im.onerror = function () { cb(null); };
        im.src = src;
      });
    }
    // the photo the shopper is looking at (before any preview): its slide and photo number
    function viewNow() {
      var i = sibRestore ? Math.round(sibRestore.left / Math.max(1, track.clientWidth)) : activeIndex();
      var sl = track.children[i], k = slideKey(sl), n = 1;
      if (k && k.kind === 'n') n = k.n;
      else if (k && k.kind === 'model') { var mi = sl.querySelector('img'); n = +((shopName(mi && mi.getAttribute('src') || '').match(/-(\d+)(?:_[0-9a-f-]{20,})?\.(?:png|jpe?g|webp)$/i) || [])[1]) || 1; }
      return { i: (k && (k.kind === 'n' || k.kind === 'model')) ? i : 0, n: (k && (k.kind === 'n' || k.kind === 'model')) ? n : 1 };
    }
    function sibPut(img, src, left) {
      if (sibRestore !== null && sibRestore.img !== img) sibBack();
      if (sibRestore === null) sibRestore = { img: img, src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), left: track.scrollLeft };
      img.removeAttribute('srcset'); img.src = src;
      if (track.scrollLeft !== left) track.scrollLeft = left;
    }
    function sibBack() {
      if (sibRestore === null) return;
      var r = sibRestore; sibRestore = null;
      if (r.img) { r.img.src = r.src; if (r.srcset) r.img.setAttribute('srcset', r.srcset); }
      track.scrollLeft = r.left;
    }
    root.addEventListener('mouseover', function (e) {
      var a = e.target.closest('[data-ts2-sibling]'); if (!a || a.classList.contains('is-selected')) return;
      clearTimeout(sibTimer);
      var sl = (data.siblings || {})[a.dataset.ts2Sibling];
      var sh = sl && sl.length ? (matchSibling(sl) || sl[0]) : null;
      if (sh && sh.pr != null) previewPrice(sh.pr);
      // preview that option on the same view the shopper is on (on-model shows its on-model photo)
      var vw = viewNow();
      sibPhoto(a.dataset.ts2Sibling, vw.n, function (src) {
        if (!a.matches(':hover')) return;
        var front = !/-(\d+)\.(?:png|jpe?g|webp)/i.test(src) || +(src.match(/-(\d+)(?:_[0-9a-f-]{20,})?\.(?:png|jpe?g|webp)/i) || [])[1] !== vw.n;
        var i = front ? 0 : vw.i;
        var img = track.children[i] && track.children[i].querySelector('img'); if (!img) return;
        sibPut(img, src, track.clientWidth * i);
      });
    });
    root.addEventListener('mouseout', function (e) {
      var a = e.target.closest('[data-ts2-sibling]'); if (!a || a.contains(e.relatedTarget)) return;
      endPreviewPrice();
      clearTimeout(sibTimer);
      sibTimer = setTimeout(sibBack, 120);
    });
  }

  // gift choice changed (or the cart was read): redraw price line + manifest
  __ts2Life.on(document, 'ts2:gift', function () { render(false); });

  /* ---------- switching quality / stone / carat keeps the same photo view ----------
     Each of those is a separate product page. On tap we remember which view is on screen (front, side,
     on-model, video...) and how far down the page is; the next page opens on the same view, at the same
     spot (the early part of that runs inline at the end of main-product-v2.liquid, before first paint).
     The gallery redraws itself after load (photo list, on-model detection), so the wanted view is kept
     until the shopper swipes the photos themselves. */
  var CARRY = 'ts2_carry', carried = null;
  try {
    carried = window.__ts2Carry || JSON.parse(sessionStorage.getItem(CARRY) || 'null');
    window.__ts2Carry = null;
    sessionStorage.removeItem(CARRY);
    if (!carried || Date.now() - carried.t > 15000 || carried.p === location.pathname) carried = null;
  } catch (e) { carried = null; }
  function slideKey(sl) {
    if (!sl) return null;
    if (sl.hasAttribute('data-video')) return { kind: 'video' };
    if (sl.hasAttribute('data-model')) return { kind: 'model' };
    if (sl.hasAttribute('data-pack')) return { kind: 'pack' };
    var img = sl.querySelector('img');
    var m = img && shopName(img.getAttribute('src') || '').match(/-(\d+)(?:_[0-9a-f-]{20,})?\.(?:png|jpe?g|webp)$/i);
    return m ? { kind: 'n', n: +m[1] } : null;
  }
  var viewGen = viewGen || 0; // bumped by every newer view choice, so an older re-check never overrides it
  function showCarried() { return carried ? showView(carried) : false; }
  // open the gallery on the view described by w = { v: slideKey, i: index } (same photo number,
  // on-model, video or packaging), falling back to the same position
  function showView(w) {
    if (!w) return false;
    var slides = $$('.ts2-slide', track), hit = -1;
    slides.forEach(function (sl, i) {
      if (hit > -1) return;
      var k = slideKey(sl);
      if (!k || !w.v || k.kind !== w.v.kind) return;
      if (k.kind !== 'n' || k.n === w.v.n) hit = i;
    });
    if (hit < 0 && w.i != null && w.i > 0 && w.i < slides.length) hit = w.i;
    if (hit < 0) return false;
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = track.clientWidth * hit;
    track.style.scrollBehavior = '';
    // a freshly redrawn gallery marks photo 1; when the position didn't change no scroll event fires,
    // so bring the dots / thumbnails / media button in step ourselves
    track.dispatchEvent(new Event('scroll'));
    // iPhone Safari can snap a just-redrawn strip back to photo 1 a moment later; put it back once,
    // unless the shopper has touched the photos in the meantime
    var want = hit, gen = ++viewGen, touched = false, mark = function () { touched = true; };
    track.addEventListener('touchstart', mark, { passive: true, once: true });
    track.addEventListener('pointerdown', mark, { passive: true, once: true });
    [60, 250].forEach(function (ms) {
      setTimeout(function () {
        if (touched || gen !== viewGen || activeIndex() === want || !track.children[want]) return;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = track.clientWidth * want;
        track.style.scrollBehavior = '';
        track.dispatchEvent(new Event('scroll'));
      }, ms);
    });
    return true;
  }
  if (carried) {
    // the shopper moving the photos themselves ends the carried view
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, function () { carried = null; }, { passive: true, once: true });
    });
    thumbs.addEventListener('click', function () { carried = null; });
    thumbs.addEventListener('mouseover', function () { carried = null; });
    mediaBtn.addEventListener('click', function () { carried = null; });
    showCarried();
    var dy = carried.y || 0;
    if (dy && Math.abs(window.pageYOffset - dy) > 2 && window.pageYOffset < 5) window.scrollTo(0, dy);
  }
  function rememberView() {
    try {
      // desktop hover-preview shows the other quality's front photo; remember the view from before the hover
      var i = (typeof sibRestore !== 'undefined' && sibRestore) ? Math.round(sibRestore.left / Math.max(1, track.clientWidth)) : activeIndex();
      sessionStorage.setItem(CARRY, JSON.stringify({ t: Date.now(), p: location.pathname, i: i, v: slideKey(track.children[i]), y: Math.round(window.pageYOffset) }));
    } catch (e) {}
  }
  // start loading the next page the moment a finger or mouse lands on the choice
  var prefetched = {};
  function prefetch(a) {
    var href = a && a.getAttribute('href');
    if (!href || prefetched[href] || a.classList.contains('is-selected')) return;
    prefetched[href] = 1;
    var l = document.createElement('link'); l.rel = 'prefetch'; l.href = href; l.as = 'document';
    document.head.appendChild(l);
  }
  root.addEventListener('pointerdown', function (e) { prefetch(e.target.closest('[data-ts2-sibling]')); }, { passive: true });
  root.addEventListener('mouseover', function (e) { var a = e.target.closest('[data-ts2-sibling]'); if (a) setTimeout(function () { if (a.matches(':hover')) prefetch(a); }, 80); });
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ts2-sibling]');
    if (!a || a.classList.contains('is-selected') || e.defaultPrevented) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
    rememberView();
  });

  /* ---------- go ---------- */
  buildRows();
  // switched in place (pdp-v2-swap.js): the page HTML may be for another carat/metal, so draw the
  // chosen one fully (gallery included) straight away
  render(!!(carried && carried.p === '(swap)'));
  applyCountry();
  fetchDelivery();
})();

/* Phone: pinned photo that eases down to ~80% while the options scroll under it (see pdp-v2.css).
   The shrink is drawn with transforms only (scale on the photo, slide on the "Selected" strip, a white
   backdrop that shortens behind them), so the page layout never changes while scrolling and nothing below
   the photo moves. The page reserves the shrunk height up front instead (CSS, from --ts2-mw/--ts2-min). */
(function(){
  var g = document.querySelector('.ts2 .ts2-gallery');
  var top = g && g.closest('.ts2-top');
  if (!g || !top) return;
  var mq = window.matchMedia('(max-width: 989px)');
  var sel = g.querySelector('.ts2-selected');
  var MIN = 0.8;
  var root = document.documentElement;
  // Where the header will END UP, not where it is mid-slide: a header sliding away (is-away / hidden class)
  // counts as gone, and any slide-in/out transform is ignored.
  function headerBottom(){
    var off = 0, hs = document.querySelectorAll('.tsx.is-pinned, .tsx-ann--scroll, .megaContainer, .shopify-section-header');
    for (var i = 0; i < hs.length; i++){
      var h = hs[i];
      if (h.classList.contains('is-away') || h.classList.contains('shopify-section-header-hidden')) continue;
      var cs = getComputedStyle(h);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      if (cs.visibility === 'hidden') continue;
      var r = h.getBoundingClientRect(), ty = 0;
      if (cs.transform && cs.transform !== 'none'){
        try { ty = new DOMMatrixReadOnly(cs.transform).m42; } catch (e) { ty = 0; }
      }
      var t0 = r.top - ty, b0 = r.bottom - ty;
      if (t0 <= 1 && b0 > off) off = b0;
    }
    return Math.max(0, Math.round(off));
  }
  var W = 0, SH = 0, MINK = MIN, startY = 0;
  function measure(){
    W = g.offsetWidth || window.innerWidth;
    SH = sel ? sel.offsetHeight : 0;
    // never let the pinned photo take more than ~45% of the screen height
    MINK = Math.min(MIN, (window.innerHeight * 0.45) / W);
    // set on the shared parent so the photo and the buy column (which reserves the space) read the same values
    top.style.setProperty('--ts2-mw', W + 'px');
    top.style.setProperty('--ts2-min', MINK.toFixed(4));
    startY = top.getBoundingClientRect().top + window.pageYOffset;
  }
  var ticking = false, on = false, lastK = -1;
  function off(){
    on = false;
    ['--ts2-k','--ts2-ky'].forEach(function(v){ g.style.removeProperty(v); });
    ['--ts2-mw','--ts2-min'].forEach(function(v){ top.style.removeProperty(v); });
    g.classList.remove('is-pinned', 'ts2-pin-js');
    root.style.removeProperty('--ts2-pin-top');
  }
  function update(){
    ticking = false;
    if (!mq.matches){ if (on) off(); return; }
    if (!on){ on = true; g.classList.add('ts2-pin-js'); measure(); }
    var pinTop = headerBottom();
    root.style.setProperty('--ts2-pin-top', pinTop + 'px');
    var y = window.pageYOffset;
    // Shrink is driven by the scroll position alone, never by the header: when the header slid away the
    // old math thought the shopper had scrolled back ~60px and the photo popped back up in size.
    var t = Math.max(0, Math.min(1, (y - startY) / (W * (1 - MINK))));
    var k = Math.round((1 - (1 - MINK) * t) * 10000) / 10000;
    if (k !== lastK){
      lastK = k;
      g.style.setProperty('--ts2-k', k);
      g.style.setProperty('--ts2-ky', ((k * W + SH) / (W + SH)).toFixed(4));
    }
    var r = g.getBoundingClientRect();
    g.classList.toggle('is-pinned', y + pinTop - startY > 0 && r.top > -2);
  }
  function req(){ if (!ticking){ ticking = true; requestAnimationFrame(update); } }
  __ts2Life.on(window, 'scroll', req, { passive: true });
  __ts2Life.on(window, 'resize', function(){ if (on){ g.style.removeProperty('--ts2-k'); measure(); lastK = -1; } req(); });
  __ts2Life.on(window, 'load', function(){ if (on){ measure(); lastK = -1; req(); } });
  if (mq.addEventListener) __ts2Life.on(mq, 'change', req);
  // The header shows/hides itself from its own scroll handler; re-check when it does so the photo moves with it.
  if (window.MutationObserver){
    var mo = __ts2Life.watch(new MutationObserver(req));
    document.querySelectorAll('.tsx, .shopify-section-header').forEach(function(h){ mo.observe(h, { attributes: true, attributeFilter: ['class'] }); });
  }
  update();
})();
